import { useEffect, useState } from "react";
import { PublicDocumentsService } from "../../services/publicDocuments/publicDocuments.service";

export function TratamientoDatosRedirectPage() {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    (async () => {
      const { error, message } = await PublicDocumentsService.getTratamientoDatos();
      if (error === true || message?.success !== true || !message?.data?.url) {
        setHasError(true);
        return;
      }
      window.location.href = message.data.url;
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4">
      {hasError ? (
        <div className="text-center">
          <h1 className="text-xl font-bold text-tdark mb-2">
            No pudimos cargar el documento
          </h1>
          <p className="text-grayP mb-6">
            Ocurrió un error al obtener la política de tratamiento de datos personales.
            Por favor intenta de nuevo más tarde.
          </p>
          <a href="/" className="text-purple font-bold hover:underline">
            Volver al inicio
          </a>
        </div>
      ) : (
        <div className="text-center">
          <p className="text-grayP text-lg">Redirigiendo al documento, un momento...</p>
        </div>
      )}
    </div>
  );
}
